module.exports = __webpack_public_path__ + "static/img/title.46e2223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title.png
// module id = 99RW
// module chunks = 1